import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_PRACTICE = 'UPDATE_PRACTICE';
export const UPDATE_PRACTICE_SUCCESS = 'UPDATE_PRACTICE_SUCCESS';
export const UPDATE_PRACTICE_FAILURE = 'UPDATE_PRACTICE_FAILURE';

// Action Creators
export const updatePracticeRequest = () => ({
  type: UPDATE_PRACTICE,
});

export const updatePracticeSuccess = (users) => ({
  type: UPDATE_PRACTICE_SUCCESS,
  payload: users,
});

export const updatePracticeFailure = (error) => ({
  type: UPDATE_PRACTICE_FAILURE,
  payload: error,
});

// Thunk Function
export const updatePractice = (external, body, id) => {
  return async (dispatch) => {
    dispatch(updatePracticeRequest());
    try {
      const response = await putMethodWithToken(
        url.updatePractice + id + '/',
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updatePracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updatePracticeFailure('error?.message'));
      }
    } catch (error) {
      dispatch(updatePracticeFailure(error?.message));
    }
  };
};
